<template>
  <div class="field RMPE-CustomField">
    <div class="control">
      <div
        class="RMPE-CustomLabel content"
        :class="labelStyle"
      >
        <div
          ref="labelContent"
          v-html="question.label"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StaticFieldMixin from '../../mixins/static-field-mixin';
import LabelFieldMixin from '../common/label-field';

export default {
  mixins: [StaticFieldMixin, LabelFieldMixin],
};
</script>

<style scoped lang="scss">
.is-size-4 {
  font-weight: 600;
}
</style>
